export default __webpack_public_path__ + "static/media/guide_img_1.3169a885.png";